import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from 'react';

import { TravelContext } from '../../controller';

import moment from 'moment';

import { useSnackbar } from 'v3/components/Snackbar';

import ConfirmModal from './Modal/ConfirmModal';
import { useModal } from 'hooks';

import { cooperplaceApi } from 'services/api';

import { FaImage } from 'react-icons/fa';

import {
  Text,
  Card,
  Upload,
  CardToWarn,
  LoadingProgressBar
} from 'v3/components';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { validate } from './validetor'

import GeneralDate from './GeneralDate';
import OwnerData from './OwnerData';
import TrackingData from './TrackingData';
import AnttData from './AnttData';

const [, useTravel] = TravelContext;

const VehicleRegisterOcr = forwardRef(({
  data,
  setData,
  errors,
  setErrors,
  setSaveLoading,
  saveLoading,
  sendResponse,
  setFrontImageCrlv,
  frontImageCrlv,
  handleClose
}, ref) => {
  const snackbar = useSnackbar();
  const confirmModal = useModal();
  const travel = useTravel();

  const [loading, setLoading] = useState(false);
  const [pendingOcrData, setPendingOcrData] = useState(null)
  const [uploadResetKey, setUploadResetKey] = useState(0);

  function validateCrlvFile(file) {
    return file?.type === 'application/pdf' && file?.name?.toLowerCase().endsWith('.pdf');
  }

  async function updateAttachment(vehicleId) {
    try {

      const attachmentsFiles = new FormData();

      const fileName = frontImageCrlv[0]?.name
        .replaceAll('_', '-')
        .split('.')
        .slice(0, -1)
        .join('.');

      const fileNameFormatted = `${Date.now()}.${frontImageCrlv[0]?.type.split('/')[1]
        }`;
      const name = fileName
        ? `${fileName}-${fileNameFormatted}`
        : fileNameFormatted;
      const newFile = new File([frontImageCrlv[0]], name, {
        type: frontImageCrlv[0]?.type,
      });

      const type = frontImageCrlv[0]?.type;
      const description = 'CRLV - Documento de Registro e Licenciamento de Veículo';
      attachmentsFiles.append('file', newFile);
      attachmentsFiles.append('type', type);
      attachmentsFiles.append('description', description);
      attachmentsFiles.append('isOcrImported', true);
      attachmentsFiles.append('dueDate', new Date().toISOString());

      await cooperplaceApi.post(
        `vehicles/${vehicleId}/attachment`,
        attachmentsFiles
      );

    } catch (error) {
      snackbar.show(<Text>Não foi possível atualizar o anexo.</Text>, {
        type: 'error',
      });
    }
  }

  function applyOcrData(ocrData, formatOcrData, vehicle) {

    setData(old => ({
      ...old,
      generalData: {
        ...old.generalData,
        plate: ocrData?.plate,
        renavam: ocrData?.renavam,
        yearModel: ocrData?.yearModel,
        yearManufacture: ocrData?.yearManufacture,
        crlv: ocrData?.crlv,
        color: formatOcrData?.color,
        axis: Number(ocrData?.axis),
        brand: formatOcrData?.brand,
        model: formatOcrData?.model,
        chassi: ocrData?.chassi,
        fuel: formatOcrData?.fuel,
        city: formatOcrData?.city,
        traction: vehicle?.veichleAxi,
        type: vehicle?.vehicleType,
        chronotachographExpDate: vehicle?.chronotachographExpDate ? moment.utc(vehicle?.chronotachographExpDate).format('YYYY-MM-DD') : '',
        chronotachographNumber: vehicle?.chronotachographNumber
      },
      ownerData: {
        ...old.ownerData,
        owner: formatOcrData?.owner,
        beneficiary: formatOcrData?.owner
      },
      anttData: {
        ...old.anttData,
        antt: vehicle?.antt,
        anttAdherence: vehicle?.anttAdherence ? moment.utc(vehicle?.anttAdherence).format('YYYY-MM-DD') : '',
        anttType: vehicle?.anttTypes,
        anttOwner: vehicle?.ownerAntt ? {
          id: vehicle?.ownerAntt?.id,
          name: vehicle?.ownerAntt?.socialName,
          label: vehicle?.ownerAntt?.socialName + (vehicle?.ownerAntt?.cpfCnpj ? ` - ${vehicle.ownerAntt.cpfCnpj}` : '')
        } : null
      },
      trackingData: {
        isTracked: vehicle?.tracked,
        trackerCode: vehicle?.trackerCode,
        tracker: vehicle?.tracker,
        trackerType: vehicle?.trackerType
      }
    }));

  }

  const extractOcrCrlv = async (file) => {
    try {
      const formData = new FormData();
      formData.append('document', file);

      setLoading(true);
      const { data } = await cooperplaceApi.post('/vehicles/extract/document/ocr', formData);

      const ocrData = data?.ocrData
      const formatOcrData = data?.formatData
      const databaseData = data?.databaseData
      const confirmUpdate = data?.isUpdate
      const vehicle = data?.vehicle

      if (confirmUpdate) {
        setPendingOcrData({ ocrData, formatOcrData, databaseData, vehicle });
        confirmModal.open();
      } else {
        applyOcrData(ocrData, formatOcrData, vehicle);
        snackbar.show(<Text>CRLV processado com sucesso!</Text>, {
          type: 'success',
        });
      }
    } catch (err) {
      setFrontImageCrlv([]);
      setUploadResetKey(k => k + 1);

      const message = err?.response?.data?.error;

      snackbar.show(<Text>{message || 'Erro ao processar o CRLV'}</Text>, {
        type: 'error',
      });

      setLoading(false);

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (frontImageCrlv?.length) {
      const file = frontImageCrlv[0];
      extractOcrCrlv(file);
    }
  }, [frontImageCrlv])


  async function handleRegister() {

    try {

      setSaveLoading(true);

      const isDataValid = await validate(data, setErrors);

      if (!isDataValid) {
        snackbar.show(<Text>Verifique os campos obrigatórios!</Text>, {
          type: 'error',
        });
        setSaveLoading(false);
        return;
      }

      const response = await cooperplaceApi.post('/vehicles/register-or-update', {
        generalData: {
          ...data.generalData,
          yearModel: Number(data.generalData.yearModel),
          yearManufacture: Number(data.generalData.yearManufacture),
        },
        anttData: {
          ...data.anttData,
          anttOwner: {
            id: data.anttData?.anttOwner?.id,
            name: data.anttData?.anttOwner?.social_name || data.anttData?.anttOwner?.name,
          }
        },
        ownerData: {
          ...data.ownerData,
          owner: {
            id: data.ownerData?.owner?.id,
            name: data.ownerData?.owner?.social_name || data.ownerData?.owner?.name,
          },
          beneficiary: {
            id: data.ownerData?.beneficiary?.id,
            name: data.ownerData?.beneficiary?.social_name || data.ownerData?.beneficiary?.name,
          }
        },
        trackingData: data.trackingData,
      });

      if (frontImageCrlv?.length && response?.data?.id) {
        await updateAttachment(response.data.id);
      }

      if (typeof sendResponse === 'function') {
        sendResponse(response);
      }

      if (travel?.setData) {
        travel.setData(old => ({
          ...old,
          vehicle: {
            ...old.vehicle,
            main: {
              id: response?.data?.id,
              plate: response?.data?.plate,
              description_service_level: response?.data?.descriptionServiceLevel,
              cooperative_type: response?.data?.cooperativeVehicleType?.description,
            }
          },
        }));
      }

      snackbar.show(<Text>Veículo registrado com sucesso!</Text>, {
        type: 'success',
      });

      handleClose();

    } catch (err) {
      console.log(err);
      const message = err?.response?.data?.error;

      snackbar.show(<Text>{message || 'Erro ao registrar o veículo'}</Text>, {
        type: 'error',
      });

      setSaveLoading(false);

    } finally {
      setSaveLoading(false);
    }
  }

  useImperativeHandle(ref, () => ({
    save: handleRegister,
  }));

  return (
    <>
      <div style={{ position: 'relative' }}>
        {(loading) && (
          <LoadingProgressBar text={loading ? 'Processando CRLV...' : 'Registrando veículo...'} />
        )}
        <Row style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
          <Col xl={5} lg={5} md={12} xs={12}>
            <CardToWarn
              text="Realize apenas o upload do CRLV,
              a IA irá extrair automaticamente os dados para o cadastro do veículo.
              Após o processamento, revise as informações extraídas e preencha os campos restantes para concluir o cadastro."
            />
            <Card
              header={
                <Text color="#464E5F" type="header">
                  Documentos
                </Text>
              }
            >
              <Upload
                key={uploadResetKey}
                sizeIcon={50}
                icon={<FaImage size={50} />}
                disabled={saveLoading}
                onChange={event =>
                  setFrontImageCrlv(event.target.files)
                }
                onFilesChange={files => {
                  if (!files?.length) {
                    setFrontImageCrlv([]);

                    setData(old => ({
                      ...old,
                      generalData: {
                        ...old.generalData,
                        plate: '',
                        renavam: '',
                        yearModel: '',
                        yearManufacture: '',
                        crlv: '',
                        color: null,
                        axis: '',
                        brand: null,
                        model: null,
                        chassi: '',
                        fuel: null,
                        city: null,
                      },
                      ownerData: {
                        ...old.ownerData,
                        owner: null,
                        beneficiary: null
                      }
                    }));
                  }
                }}
                value={frontImageCrlv}
                id="imgCrlv"
                name="imgCrlv"
                accept={['.pdf']}
                label="Arquivo máximo de 10MB"
                maxFileSize={10485760}
                showPreview={true}
                validate={validateCrlvFile}
                onValidationError={() =>
                  snackbar.show(<Text>Apenas arquivos PDF são aceitos para o processamento.</Text>, {
                    type: 'error',
                  })
                }
              />
              <Col style={{ marginTop: 8 }}>
                {!frontImageCrlv?.length && (
                  <CardToWarn
                    text="⛔ Apenas arquivos no formato PDF são aceitos. Faça o upload do CRLV em PDF para continuar."
                    backgroundColor="#FDECEA"
                    borderColor="#F44336"
                    textColor="#C62828"
                  />
                )}
              </Col>
            </Card>
          </Col>

          <Col xl={7} lg={7} md={12} xs={12} key={frontImageCrlv?.length ? 'with-image' : 'no-image'}>
            <GeneralDate
              setData={generalData => setData({ ...data, generalData })}
              data={data?.generalData}
              errors={errors?.generalData}
              fildsDisabled={!frontImageCrlv?.length}
              saveLoading={saveLoading}
              frontImageCrlv={frontImageCrlv}
            />

            <AnttData
              setData={anttData => setData({ ...data, anttData })}
              data={data?.anttData}
              errors={errors?.anttData}
              saveLoading={saveLoading}
            />

            <OwnerData
              setData={ownerData => setData({ ...data, ownerData })}
              data={data?.ownerData}
              errors={errors?.ownerData}
              saveLoading={saveLoading}
            />

            <TrackingData
              setData={trackingData => setData({ ...data, trackingData })}
              data={data?.trackingData}
              errors={errors?.trackingData}
              saveLoading={saveLoading}
              isDisabled={saveLoading}
            />
          </Col>
        </Row>
      </div>

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={confirmModal.close}
        data={pendingOcrData?.databaseData}
        onConfirm={() => {
          if (pendingOcrData) {
            applyOcrData(pendingOcrData.ocrData, pendingOcrData.formatOcrData, pendingOcrData.vehicle);
            snackbar.show(<Text>CNH processada com sucesso!</Text>, { type: 'success' });
            setPendingOcrData(null);
          }
          confirmModal.close();
        }}
        setFrontImageCnh={() => { setFrontImageCrlv([]); setUploadResetKey(k => k + 1); }}
      />
    </>
  );
});

export default VehicleRegisterOcr;
